import env from "$root/env";
import type { AxiosInstance } from "axios";
import { Configuration } from "@eu.mdotm.api/sphere";
import { authAxiosInstance } from "./config";

export type ControllerFactory<T> = (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) => T;

/**
 * Example:
 * ```tsx
 * const portfolioApi = makeAuthController({ controllerFactory: InvestmentsControllerApiFactory });
 * ```
 */
export function makeController<T>(controllerFactory: ControllerFactory<T>, axiosInstance: AxiosInstance): T {
	return controllerFactory(
		new Configuration({
			get basePath() {
				return env.apiOrigin;
			},
		}),
		undefined,
		axiosInstance,
	);
}

/**
 * Like {@link useApiGen}, but it's not a hook, so it can be called anywhere in the code.
 *
 * Example:
 * ```tsx
 * const portfolioApi = getApiGen(InvestmentsControllerApiFactory);
 * ```
 */
export function getApiGen<T>(controllerFactory: ControllerFactory<T>, axiosInstance?: AxiosInstance): T {
	const api = makeController(controllerFactory, axiosInstance ?? authAxiosInstance);
	return api;
}
